module.exports = __webpack_public_path__ + "static/media/19.ce571d68.mp3";